import { useState, useEffect } from 'react';
import { getValue } from 'firebase/remote-config';
import { remoteConfig } from '../lib/firebase';
import type { AccountSection } from '../types/account';
import log from '../utils/logger';

export const useAccountSections = () => {
    const [accountSections, setAccountSections] = useState<AccountSection[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadAccountSections = () => {
            try {
                setLoading(true);
                // Note: remoteConfig is already fetched and activated in App.tsx
                // so we can safely use getValue here
                const accountSectionsValue = getValue(remoteConfig, 'accountSections');
                const sectionsString = accountSectionsValue.asString();
                
                if (sectionsString) {
                    const sections = JSON.parse(sectionsString) as AccountSection[];
                    setAccountSections(sections);
                    log.debug('📱 Account sections loaded:', sections);
                } else {
                    setAccountSections([]);
                }
                setError(null);
            } catch (err) {
                log.error('Error loading account sections:', err);
                setError('Failed to load account sections');
                setAccountSections([]);
            } finally {
                setLoading(false);
            }
        };

        loadAccountSections();
    }, []);

    // Funzione per trovare un item specifico per ID
    const findItemById = (itemId: string) => {
        for (const section of accountSections) {
            const item = section.items.find(item => item.id === itemId);
            if (item) {
                return item;
            }
        }
        return null;
    };

    return {
        accountSections,
        loading,
        error,
        findItemById
    };
};